import React from 'react';
import { View } from 'react-native';
import { useNavigation, useRoute, type RouteProp } from '@react-navigation/native';
import type { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { useTranslation } from 'react-i18next';
import { MainLayout } from '@shared/components/md-design-system/Layout/MainLayout';
import { Head } from '@shared/components/head';
import { Text } from '@shared/components/text';
import Button from '@shared/components/md-design-system/Button/Button';
import { ActivityName } from '../types';

type RemeasurementStartRouteParams = {
    measurementId: string;
    vitalParameterName?: string;
};

type RemeasurementStartRouteProp = RouteProp<
    Record<string, RemeasurementStartRouteParams>,
    string
>;

type RemeasurementStartNavigationProp = NativeStackNavigationProp<any>;

export const RemeasurementStartScreen = () => {
    const navigation = useNavigation<RemeasurementStartNavigationProp>();
    const route = useRoute<RemeasurementStartRouteProp>();
    const { measurementId, vitalParameterName } = route.params;
    const { t } = useTranslation();

    const handleGoBack = () => {
        navigation.goBack();
    };

    const handleStartRemeasurement = () => {
        const activityName = vitalParameterName as ActivityName;
        const remeasurementActivityId = `remeasurement_${measurementId}_${Date.now()}`;
        navigation.navigate('MeasurementFlow', {
            activityName,
            activityId: remeasurementActivityId,
            isRemeasurement: true,
            originalMeasurementId: measurementId,
            initialStep: 1,
        });
    };


    return (
        <MainLayout navigation={handleGoBack}>
            <View className="flex-1 justify-between py-6">
                <View className="gap-6">
                    <View className="gap-4">
                        <Head type="h2" className="">
                            {t('screens.remeasurement.start_screen.remeasure')}
                        </Head>
                        <Text className="text text-gray-600">
                            {t('screens.remeasurement.start_screen.first_block')}
                        </Text>
                    </View>
                </View>

                <View className="pt-6">
                    <Button
                        variant="primary"
                        size="large"
                        onPress={handleStartRemeasurement}
                    >
                        {t('screens.remeasurement.start_screen.remeasure')}
                    </Button>
                </View>
            </View>
        </MainLayout>
    );
};

export default RemeasurementStartScreen;
